// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 517) return "static/chunks/517-76f56ea91442eb3a.js";
	if (chunkId === 839) return "static/chunks/839-f134f4fd0b918d32.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"84617cb5acee125d","205":"142f13705c668700","319":"0cbc2894a3f1b950","340":"2eefe4128672c61e","367":"25671a602c8dbc5e","639":"a322f5d778fbd249","748":"b45ba7e46adaa3bf"}[chunkId] + ".js";
};